const data = {
  locations: [
    {
      id: "5001",
      name: "Hidalgo Enrollment Center",
      city: "Mission",
      state: "TX",
      countryCode: "US",
      shortName: "Hidalgo Enrollment Center",
      urlString: "hidalgo-enrollment-center",
      waitTimeDays: 0,
      postalCode: "78572",
      coordinates: [26.229223, -98.37545],
    },
    {
      urlString: "san-diego-otay-mesa-enrollment-center",
      city: "San Diego",
      coordinates: [32.557022, -117.006214],
      name: "San Diego -Otay Mesa Enrollment Center",
      id: "5002",
      waitTimeDays: 205,
      state: "CA",
      postalCode: "92154",
      shortName: "San Diego -Otay Mesa Enrollment Center",
      countryCode: "US",
    },
    {
      postalCode: "78521",
      countryCode: "US",
      id: "5003",
      coordinates: [25.943923, -97.317944],
      waitTimeDays: 36,
      urlString: "brownsville-enrollment-center",
      city: "Brownsville",
      state: "TX",
      shortName: "Brownsville Enrollment Center",
      name: "Brownsville Enrollment Center",
    },
    {
      id: "5004",
      urlString: "laredo-enrollment-center",
      city: "Laredo",
      waitTimeDays: 0,
      postalCode: "780443130",
      name: "Laredo Enrollment Center",
      countryCode: "US",
      state: "TX",
      shortName: "Laredo Enrollment Center",
    },
    {
      waitTimeDays: 135,
      postalCode: "79907",
      urlString: "el-paso-enrollment-center",
      name: "El Paso Enrollment Center",
      id: "5005",
      shortName: "El Paso Enrollment Center",
      state: "TX",
      coordinates: [31.707231, -106.326563],
      city: "El Paso",
      countryCode: "US",
    },
    {
      coordinates: [32.687552, -115.541028],
      urlString: "calexico-enrollment-center",
      name: "Calexico Enrollment Center",
      waitTimeDays: 169,
      city: "Calexico",
      countryCode: "US",
      id: "5006",
      shortName: "Calexico Enrollment Center",
      state: "CA",
      postalCode: "92231",
    },
    {
      name: "Nogales, AZ",
      urlString: "nogales-az",
      waitTimeDays: 35,
      id: "5007",
      shortName: "Nogales Enrollment Center",
      city: "NOGALES",
      coordinates: [31.387978, -110.912001],
      state: "AZ",
      postalCode: "85621",
      countryCode: "US",
    },
    {
      waitTimeDays: 7,
      shortName: "Champlain Enrollment Center",
      coordinates: [44.964539, -73.447083],
      urlString: "champlain-enrollment-center",
      state: "NY",
      postalCode: "12919",
      countryCode: "US",
      id: "5021",
      name: "Champlain Enrollment Center",
      city: "Champlain",
    },
    {
      shortName: "Buffalo-Ft. Erie Enrollment Center",
      urlString: "buffalo-ft-erie-enrollment-center",
      city: "FORT ERIE",
      countryCode: "CA",
      state: "ON",
      coordinates: [42.906043, -78.916235],
      id: "5022",
      postalCode: "L2A6G6",
      waitTimeDays: 365,
      name: "Buffalo-Ft. Erie Enrollment Center",
    },
    {
      waitTimeDays: 13,
      state: "MI",
      urlString: "detroit-enrollment-center",
      id: "5023",
      shortName: "Detroit Enrollment Center",
      city: "Detroit",
      countryCode: "US",
      postalCode: "48216",
      coordinates: [42.326485, -83.078746],
      name: "Detroit Enrollment Center",
    },
    {
      urlString: "port-huron-enrollment-center",
      state: "MI",
      city: "Port Huron",
      name: "Port Huron Enrollment Center",
      id: "5024",
      postalCode: "48060",
      waitTimeDays: 57,
      coordinates: [42.980388, -82.461014],
      shortName: "Port Huron Enrollment Center",
      countryCode: "US",
    },
    {
      waitTimeDays: 365,
      postalCode: "K1V0R4",
      state: "ON",
      name: "Ottawa International Airport",
      city: "Ottawa",
      shortName: "Ottawa Enrollment Center",
      coordinates: [45.325365, -75.654057],
      countryCode: "CA",
      urlString: "ottawa-international-airport",
      id: "5025",
    },
    {
      shortName: "Vancouver Enrollment Center",
      id: "5026",
      state: "BC",
      name: "Vancouver Enrollment Center",
      city: "Richmond",
      countryCode: "CA",
      coordinates: [49.197589, -123.136614],
      urlString: "vancouver-enrollment-center",
      waitTimeDays: 365,
      postalCode: "V7B1Y9",
    },
    {
      urlString: "toronto-enrollment-center",
      city: "Mississauga",
      state: "ON",
      waitTimeDays: 365,
      countryCode: "CA",
      id: "5027",
      name: "Toronto Enrollment Center",
      coordinates: [43.682567, -79.596794],
      postalCode: "L5P1B2",
      shortName: "Toronto Enrollment Center",
    },
    {
      waitTimeDays: 365,
      shortName: "Montreal Enrollment Center",
      postalCode: "H2Y1H1",
      name: "Montreal Enrollment Center",
      urlString: "montreal-enrollment-center",
      id: "5028",
      countryCode: "CA",
      state: "QC",
      city: "Montreal",
      coordinates: [45.50825, -73.552295],
    },
    {
      waitTimeDays: 365,
      name: "Winnipeg Enrollment Center",
      state: "MB",
      countryCode: "CA",
      id: "5029",
      city: "Winnipeg",
      postalCode: "R3H0E3",
      shortName: "Winnipeg Enrollment Center",
      coordinates: [49.905925, -97.223405],
      urlString: "winnipeg-enrollment-center",
    },
    {
      state: "AB",
      name: "Calgary Enrollment Center",
      id: "5030",
      countryCode: "CA",
      coordinates: [51.130257, -114.009656],
      shortName: "Calgary Enrollment Center",
      city: "Calgary",
      waitTimeDays: 365,
      urlString: "calgary-enrollment-center",
      postalCode: "T2E6W5",
    },
    {
      urlString: "halifax-enrollment-center",
      state: "NS",
      waitTimeDays: 365,
      name: "Halifax Enrollment Center",
      coordinates: [44.886808, -63.514921],
      shortName: "Halifax Enrollment Center",
      postalCode: "B2T1K2",
      city: "Goffs",
      id: "5031",
      countryCode: "CA",
    },
    {
      waitTimeDays: 365,
      id: "5032",
      urlString: "edmonton-enrollment-center",
      countryCode: "CA",
      name: "Edmonton Enrollment Center",
      shortName: "Edmonton Enrollment Center",
      coordinates: [53.30963, -113.58503],
      state: "AB",
      city: "Edmonton",
      postalCode: "T9E0V3",
    },
    {
      coordinates: [49.271194, -123.101309],
      name: "Vancouver Urban Enrollment Center",
      shortName: "Vancouver Urban Enrollment Center",
      waitTimeDays: 365,
      state: "BC",
      city: "VANCOUVER",
      postalCode: "V6A2W5",
      id: "5041",
      urlString: "vancouver-urban-enrollment-center",
      countryCode: "CA",
    },
    {
      countryCode: "US",
      coordinates: [48.815298, -95.360862],
      id: "5060",
      city: "Warroad",
      postalCode: "56763",
      urlString: "warroad-enrollment-center",
      waitTimeDays: 0,
      shortName: "Warroad Enrollment Center ",
      state: "MN",
      name: "Warroad Enrollment Center ",
    },
    {
      countryCode: "US",
      city: "Sault Ste. Marie",
      waitTimeDays: 0,
      shortName: "Sault Ste Marie EC",
      name: "Sault Ste Marie Enrollment Center",
      coordinates: [46.416901, -84.289054],
      id: "5080",
      state: "MI",
      urlString: "sault-ste-marie-enrollment-center",
      postalCode: "49783",
    },
    {
      id: "5101",
      name: "Houlton POE/Woodstock",
      urlString: "houlton-poe-woodstock",
      state: "NB",
      shortName: "Houlton Enrollment Center",
      city: "Belleville",
      postalCode: "E7M4Z9",
      waitTimeDays: 365,
      countryCode: "CA",
    },
    {
      waitTimeDays: 365,
      shortName: "Sweetgrass NEXUS and FAST",
      coordinates: [48.967184, -111.658692],
      postalCode: "59484",
      city: "Sweetgrass",
      id: "5120",
      state: "MT",
      urlString: "sweetgrass-nexus-and-fast-enrollment-center",
      countryCode: "US",
      name: "Sweetgrass NEXUS and FAST Enrollment Center",
    },
    {
      state: "NY",
      id: "5140",
      shortName: "JFK International Global Entry EC",
      name: "JFK International Global Entry EC",
      city: "Jamaica",
      postalCode: "11430",
      urlString: "jfk-international-global-entry-ec",
      waitTimeDays: 365,
      coordinates: [40.646964, -73.784813],
      countryCode: "US",
    },
    {
      waitTimeDays: 70,
      id: "5141",
      countryCode: "US",
      postalCode: "77032",
      urlString: "houston-intercontinental-global-entry-ec",
      shortName: "Houston Intercontinental",
      city: "Houston",
      state: "TX",
      coordinates: [29.987805, -95.353412],
      name: "Houston Intercontinental Global Entry EC",
    },
    {
      waitTimeDays: 365,
      shortName: "Washington Dulles International Global Entry EC",
      urlString: "washington-dulles-international-global-entry-ec",
      postalCode: "20041",
      countryCode: "US",
      state: "VA",
      name: "Washington Dulles International Global Entry EC",
      id: "5142",
      city: "Sterling ",
    },
    {
      postalCode: "56649",
      urlString: "international-falls-enrollment-center",
      id: "5160",
      shortName: "International Falls EC",
      city: "International Falls",
      coordinates: [48.574989, -92.917067],
      waitTimeDays: 365,
      countryCode: "US",
      name: "International Falls Enrollment Center",
      state: "MN",
    },
    {
      postalCode: "14305",
      coordinates: [43.122831, -79.023218],
      countryCode: "US",
      waitTimeDays: 255,
      state: "NY",
      city: "NIAGARA FALLS",
      name: "Niagara Falls Enrollment Center",
      id: "5161",
      shortName: "Niagara Falls EC",
      urlString: "niagara-falls-enrollment-center",
    },
    {
      name: "Los Angeles International Global Entry EC",
      id: "5180",
      city: "LOS ANGELES",
      postalCode: "90045",
      urlString: "los-angeles-international-global-entry-ec",
      coordinates: [33.942108, -118.417488],
      shortName: "Los Angeles International Global Entry EC",
      waitTimeDays: 272,
      countryCode: "US",
      state: "CA",
    },
    {
      id: "5181",
      postalCode: "33126",
      shortName: "Miami International Global Entry EC",
      coordinates: [25.7794, -80.299475],
      urlString: "miami-international-airport",
      state: "FL",
      city: "Miami",
      countryCode: "US",
      waitTimeDays: 13,
      name: "Miami International Airport",
    },
    {
      waitTimeDays: 365,
      state: "GA",
      id: "5182",
      shortName: "Atlanta International Global Entry EC",
      countryCode: "US",
      city: "Atlanta",
      name: "Atlanta International Global Entry EC",
      postalCode: "30320",
      urlString: "atlanta-international-global-entry-ec",
    },
    {
      name: "Chicago O'Hare International Global Entry EC ",
      urlString: "chicago-o'hare-international-global-entry-ec",
      shortName: "Chicago O'Hare International Global Entry EC ",
      city: "CHICAGO",
      countryCode: "US",
      waitTimeDays: 57,
      id: "5183",
      state: "IL",
      postalCode: "60666",
    },
    {
      countryCode: "US",
      postalCode: "30320",
      city: "Atlanta",
      state: "GA",
      shortName: "Atlanta Port Office Global Entry Enrollment Center",
      waitTimeDays: 365,
      id: "5200",
      name: "Atlanta Port Office Global Entry Enrollment Center",
      urlString: "atlanta-port-office-global-entry-enrollment-center",
    },
    {
      city: "Derby Line",
      urlString: "derby-line-enrollment-center",
      state: "VT",
      waitTimeDays: 28,
      postalCode: "08530",
      shortName: "Derby Line Enrollment Center",
      name: "Derby Line Enrollment Center",
      id: "5223",
      countryCode: "US",
    },
    {
      postalCode: "75261",
      id: "5300",
      city: "DFW Airport",
      state: "TX",
      waitTimeDays: 90,
      shortName: "Dallas-Fort Worth Intl Airport Global Entry",
      countryCode: "US",
      urlString: "dallas-fort-worth-international-airport-global-entry",
      name: "Dallas-Fort Worth International Airport Global Entry",
    },
    {
      postalCode: "48242",
      countryCode: "US",
      waitTimeDays: 71,
      shortName: "Detroit Metro Airport Global Entry",
      name: "Detroit Metro Airport",
      state: "MI",
      city: "Detroit",
      coordinates: [42.22121, -83.345136],
      id: "5320",
      urlString: "detroit-metro-airport",
    },
    {
      waitTimeDays: 125,
      shortName: "Honolulu Enrollment Center",
      city: "Honolulu",
      state: "HI",
      coordinates: [21.347117, -157.877317],
      urlString: "honolulu-enrollment-center",
      postalCode: "96819",
      countryCode: "US",
      name: "Honolulu Enrollment Center",
      id: "5340",
    },
    {
      id: "5360",
      coordinates: [36.084721, -115.146129],
      state: "NV",
      shortName: "Las Vegas Enrollment Center",
      city: "Las Vegas",
      postalCode: "89119",
      urlString: "las-vegas-enrollment-center",
      countryCode: "US",
      waitTimeDays: 365,
      name: "Las Vegas Enrollment Center",
    },
    {
      state: "FL",
      name: "Orlando International Airport",
      city: "Orlando",
      postalCode: "32827",
      coordinates: [28.415581, -81.29899],
      id: "5380",
      shortName: "Orlando Global Entry Enrollment Center",
      countryCode: "US",
      waitTimeDays: 83,
      urlString: "orlando-international-airport",
    },
    {
      state: "PR",
      shortName: "San Juan Global Entry Enrollment Center",
      postalCode: "00983",
      urlString: "san-juan-global-entry-enrollment-center",
      countryCode: "US",
      waitTimeDays: 8,
      id: "5400",
      city: "Carolina",
      name: "San Juan Global Entry Enrollment Center",
    },
    {
      countryCode: "US",
      waitTimeDays: 18,
      urlString: "seatac-international-airport-global-entry-ec",
      name: "Seatac International Airport Global Entry EC",
      id: "5420",
      shortName: "SeaTac International Airport Global Entry EC",
      postalCode: "98158",
      coordinates: [47.449678, -122.307657],
      city: "Seattle",
      state: "WA",
    },
    {
      waitTimeDays: 365,
      id: "5441",
      urlString: "boston-logan-global-entry-enrollment-center",
      name: "Boston-Logan Global Entry Enrollment Center",
      postalCode: "02128",
      shortName: "Boston-Logan Global Entry Enrollment Center",
      city: "East Boston",
      countryCode: "US",
      state: "MA",
    },
    {
      id: "5443",
      shortName: "Fort Lauderdale Global Entry Enrollment Center",
      postalCode: "33316",
      coordinates: [26.098738, -80.121896],
      waitTimeDays: 91,
      city: "Ft Lauderdale",
      countryCode: "US",
      urlString: "fort-lauderdale-global-entry-enrollment-center",
      name: "Fort Lauderdale Global Entry Enrollment Center",
      state: "FL",
    },
    {
      waitTimeDays: 183,
      urlString: "newark-liberty-intl-airport",
      countryCode: "US",
      name: "Newark Liberty Intl Airport",
      city: "Newark ",
      postalCode: "07114",
      id: "5444",
      shortName: "Newark Global Entry Enrollment Center",
      state: "NJ",
    },
    {
      postalCode: "19153",
      id: "5445",
      countryCode: "US",
      name: "Philadelphia International Airport",
      coordinates: [39.893446, -75.229648],
      city: "PHILADELPHIA",
      waitTimeDays: 365,
      state: "PA",
      urlString: "philadelphia-international-airport",
      shortName: "Philadelphia Global Entry Enrollment Center",
    },
    {
      shortName: "SF Enrollment Center",
      state: "CA",
      waitTimeDays: 99,
      urlString: "san-francisco-global-entry-enrollment-center",
      postalCode: "94128",
      name: "San Francisco Global Entry Enrollment Center",
      id: "5446",
      countryCode: "US",
      coordinates: [37.626411, -122.385757],
      city: "San Francisco",
    },
    {
      postalCode: "32773",
      city: "Sanford",
      shortName: "Sanford Global Entry Enrollment Center",
      countryCode: "US",
      coordinates: [28.754849, -81.246937],
      id: "5447",
      waitTimeDays: 365,
      urlString: "sanford-global-entry-enrollment-center",
      state: "FL",
      name: "Sanford Global Entry Enrollment Center",
    },
    {
      city: "San Luis",
      postalCode: "85349",
      waitTimeDays: 231,
      urlString: "san-luis-enrollment-center",
      name: "San Luis Enrollment Center",
      countryCode: "US",
      coordinates: [32.508824, -114.743975],
      id: "5460",
      shortName: "San Luis Enrollment Center",
      state: "AZ",
    },
    {
      shortName: "Calais Enrollment Center",
      postalCode: "04619",
      urlString: "calais-enrollment-center",
      city: "Calais",
      waitTimeDays: 0,
      id: "5500",
      name: "Calais Enrollment Center",
      countryCode: "US",
      state: "ME",
    },
    {
      shortName: "Lansdowne, ON ",
      postalCode: "K0E1L0",
      name: "Lansdowne, ON ",
      coordinates: [44.397935, -76.036624],
      urlString: "lansdowne-on",
      state: "ON",
      waitTimeDays: 365,
      id: "5520",
      countryCode: "CA",
      city: "Lansdowne",
    },
    {
      id: "6480",
      waitTimeDays: 365,
      urlString: "us-custom-house-bowling-green",
      name: "U.s. Custom House - Bowling Green",
      shortName: "Bowling Green",
      countryCode: "US",
      city: "NEW YORK",
      state: "NY",
      postalCode: "10004",
      coordinates: [40.68863, -74.018244],
    },
    {
      coordinates: [44.878385, -93.196359],
      waitTimeDays: 128,
      city: "St. Paul",
      shortName: "Minneapolis - St. Paul Airport",
      urlString: "minneapolis-st-paul-global-entry-ec",
      countryCode: "US",
      id: "6840",
      postalCode: "55111",
      name: "Minneapolis - St. Paul Global Entry EC",
      state: "MN",
    },
    {
      countryCode: "QA",
      id: "6920",
      name: "Doha International Airport",
      state: "",
      waitTimeDays: 31,
      urlString: "doha-international-airport",
      shortName: "Doha International Airport",
      city: "Doha",
      postalCode: "",
    },
    {
      postalCode: "80249",
      city: "Denver",
      name: "Denver International Airport",
      countryCode: "US",
      waitTimeDays: 195,
      urlString: "denver-international-airport",
      shortName: "Denver International Airport",
      id: "6940",
      state: "CO",
      coordinates: [39.854746, -104.695804],
    },
    {
      waitTimeDays: 161,
      coordinates: [33.42958, -112.014097],
      postalCode: "85034",
      urlString: "phoenix-sky-harbor-global-entry-enrollment-center",
      city: "Phoenix",
      countryCode: "US",
      name: "Phoenix Sky Harbor Global Entry Enrollment Center",
      shortName: "Phoenix Sky Harbor Global Entry Enrollment Center",
      state: "AZ",
      id: "7160",
    },
    {
      coordinates: [29.987805, -95.353412],
      shortName: "Houston Term E - BOARDING PASS REQUIRED TO ENT    ",
      urlString: "houston-hobby-airport-enrollment-center",
      waitTimeDays: 365,
      countryCode: "US",
      id: "7480",
      city: "Houston",
      postalCode: "77032",
      name: "Houston Hobby Airport Enrollment Center",
      state: "TX",
    },
    {
      shortName: "San Antonio International Airport",
      postalCode: "78216",
      urlString: "san-antonio-international-airport",
      waitTimeDays: 365,
      id: "7520",
      city: "San Antonio",
      coordinates: [29.537264, -98.487882],
      name: "San Antonio International Airport",
      countryCode: "US",
      state: "TX",
    },
    {
      urlString: "anchorage-enrollment-center",
      countryCode: "US",
      city: "Anchorage ",
      waitTimeDays: 1,
      name: "Anchorage Enrollment Center",
      postalCode: "99502",
      coordinates: [61.163643, -149.996609],
      state: "AK",
      id: "7540",
      shortName: "Anchorage Enrollment Center",
    },
    {
      name: "Salt Lake City International Airport",
      countryCode: "US",
      urlString: "salt-lake-city-international-airport",
      id: "7600",
      postalCode: "84116",
      waitTimeDays: 105,
      coordinates: [40.802748, -111.957032],
      shortName: "Salt Lake City International Airport",
      city: "Salt Lake City",
      state: "UT",
    },
    {
      name: "Cincinnati Enrollment Center",
      id: "7680",
      postalCode: "41018",
      state: "KY",
      waitTimeDays: 365,
      coordinates: [39.014901, -84.602186],
      shortName: "Cincinnati Enrollment Center",
      city: "Erlanger",
      urlString: "cincinnati-enrollment-center",
      countryCode: "US",
    },
    {
      coordinates: [42.977392, -87.898851],
      urlString: "milwaukee-enrollment-center",
      postalCode: "53207",
      city: "Milwaukee",
      shortName: "Milwaukee Enrollment Center",
      countryCode: "US",
      name: "Milwaukee Enrollment Center",
      waitTimeDays: 365,
      state: "WI",
      id: "7740",
    },
    {
      id: "7820",
      city: "Austin",
      coordinates: [30.195372, -97.668445],
      shortName: "Austin-Bergstrom International Airport",
      postalCode: "78719",
      state: "TX",
      name: "Austin-Bergstrom International Airport",
      urlString: "austin-bergstrom-international-airport",
      waitTimeDays: 365,
      countryCode: "US",
    },
    {
      city: "Linthicum",
      name: "Balt/Wash Intl Thurgood Marshall Airport",
      state: "MD",
      shortName: "Baltimore Enrollment Center",
      urlString: "balt-wash-intl-thurgood-marshall-airport",
      coordinates: [39.17428, -76.671514],
      waitTimeDays: 140,
      countryCode: "US",
      id: "7940",
      postalCode: "21240",
    },
    {
      name: "Portland, OR Enrollment Center",
      shortName: "Portland, OR Enrollment Center",
      urlString: "portland-or-enrollment-center",
      postalCode: "97220",
      state: "OR",
      city: "Portland",
      coordinates: [45.550024, -122.559297],
      countryCode: "US",
      id: "7960",
      waitTimeDays: 325,
    },
    {
      waitTimeDays: 365,
      urlString: "tampa-enrollment-center",
      city: "Tampa",
      postalCode: "33607",
      id: "8020",
      state: "FL",
      countryCode: "US",
      coordinates: [27.962012, -82.492176],
      name: "Tampa Enrollment Center",
      shortName: "Tampa Enrollment Center",
    },
    {
      id: "8040",
      city: "Albuquerque",
      waitTimeDays: 43,
      urlString: "albuquerque-enrollment-center",
      name: "Albuquerque Enrollment Center",
      coordinates: [35.057863, -106.620735],
      countryCode: "US",
      state: "NM",
      shortName: "Albuquerque Enrollment Center",
      postalCode: "87106",
    },
    {
      coordinates: [31.520779, -109.37922],
      urlString: "douglas-enrollment-center",
      countryCode: "US",
      city: "Douglas",
      name: "Douglas Enrollment Center",
      id: "8100",
      postalCode: "85607",
      waitTimeDays: 29,
      state: "AZ",
      shortName: "Douglas Enrollment Center",
    },
    {
      postalCode: "20229",
      city: "Washington",
      name: "Washington, DC Enrollment Center",
      urlString: "washington-dc-enrollment-center",
      id: "8120",
      state: "DC",
      waitTimeDays: 91,
      countryCode: "US",
      shortName: "Ronald Reagan BLD",
    },
    {
      city: "Long Beach",
      shortName: "Permanently Closed",
      coordinates: [33.745762, -118.208042],
      postalCode: "90802",
      waitTimeDays: 365,
      name: "Los Angeles -Long Beach Seaport ",
      urlString: "los-angeles-long-beach-seaport",
      countryCode: "US",
      id: "8920",
      state: "CA",
    },
    {
      waitTimeDays: 365,
      state: "",
      name: "Singapore (Singapore, U.S. Embassy) ",
      shortName: "Singapore, U.S. Embassy",
      id: "9040",
      city: "Singapore",
      countryCode: "SG",
      urlString: "singapore-singapore-us-embassy",
      postalCode: "258508",
    },
    {
      coordinates: [47.965288, -89.73713],
      state: "MN",
      waitTimeDays: 0,
      name: "Grand Portage",
      city: "Grand Portage",
      postalCode: "55605",
      countryCode: "US",
      shortName: "Grand Portage GE EC",
      id: "9101",
      urlString: "grand-portage",
    },
    {
      id: "9140",
      city: "Tamuning",
      countryCode: "US",
      waitTimeDays: 1,
      postalCode: "96913",
      urlString: "guam-international-airport",
      name: "Guam International Airport",
      coordinates: [13.477839, 144.814522],
      shortName: "Guam International Airport",
      state: "GU",
    },
    {
      waitTimeDays: 112,
      postalCode: "44130",
      coordinates: [41.376642, -81.787317],
      id: "9180",
      city: "Middleburg Heights",
      countryCode: "US",
      urlString: "cleveland-us-customs-and-border-protection",
      name: "Cleveland U.S. Customs and border protection",
      shortName: "Cleveland U.S. Customs and Border Protection",
      state: "OH",
    },
    {
      shortName: "Pittsburgh International Airport",
      urlString: "pittsburgh-international-airport",
      postalCode: "15231",
      countryCode: "US",
      waitTimeDays: 365,
      name: "Pittsburgh International Airport",
      city: "Pittsburgh",
      state: "PA",
      id: "9200",
    },
    {
      waitTimeDays: 105,
      countryCode: "US",
      name: "Tucson Enrollment Center",
      state: "AZ",
      shortName: "Tucson Enrollment Center",
      urlString: "tucson-enrollment-center",
      city: "Tucson",
      id: "9240",
      coordinates: [32.079259, -110.898921],
      postalCode: "85756",
    },
    {
      name: "West Palm Beach Enrollment Center",
      id: "9260",
      coordinates: [26.781022, -80.063738],
      postalCode: "33404",
      waitTimeDays: 89,
      urlString: "west-palm-beach-enrollment-center",
      state: "FL",
      countryCode: "US",
      shortName: "West Palm Beach Enrollment Center",
      city: "Riviera Beach",
    },
    {
      postalCode: "02888",
      city: "Warwick",
      countryCode: "US",
      waitTimeDays: 365,
      urlString: "warwick-ri-enrollment-center",
      shortName: "Warwick, RI Enrollment Center",
      state: "RI",
      name: "Warwick, RI Enrollment Center",
      id: "9300",
    },
    {
      state: "LA",
      id: "9740",
      postalCode: "70062",
      waitTimeDays: 69,
      shortName: "New Orleans Enrollment Center",
      countryCode: "US",
      name: "New Orleans Enrollment Center",
      coordinates: [29.991693, -90.258179],
      urlString: "new-orleans-enrollment-center",
      city: "Kenner",
    },
    {
      waitTimeDays: 365,
      id: "10260",
      shortName: "Nashville Enrollment Center",
      postalCode: "37217",
      countryCode: "US",
      name: "Nashville Enrollment Center",
      urlString: "nashville-enrollment-center",
      city: "Nashville",
      state: "TN",
      coordinates: [36.108666, -86.656722],
    },
    {
      shortName: "Moline Quad Cities International Airport",
      postalCode: "61265",
      countryCode: "US",
      urlString: "moline-quad-cities-international-airport",
      state: "IL",
      name: "Moline Quad Cities International Airport",
      waitTimeDays: 365,
      city: "Moline",
      id: "11000",
      coordinates: [41.482333, -90.493407],
    },
    {
      name: "Rockford-Chicago International Airport",
      coordinates: [42.191304, -89.055756],
      urlString: "rockford-chicago-international-airport",
      state: "IL",
      city: "Rockford",
      id: "11001",
      postalCode: "61109",
      waitTimeDays: 259,
      shortName: "Rockford-Chicago International Airport",
      countryCode: "US",
    },
    {
      city: "Peoria",
      urlString: "peoria-international-airport",
      shortName: "Peoria International Airport",
      countryCode: "US",
      postalCode: "61607",
      name: "Peoria international airport",
      state: "IL",
      waitTimeDays: 365,
      coordinates: [40.627135, -89.685132],
      id: "11002",
    },
    {
      state: "OH",
      shortName: "Port Clinton, Ohio Enrollment Center",
      coordinates: [41.515792, -82.980945],
      id: "11841",
      waitTimeDays: 71,
      urlString: "port-clinton-ohio-enrollment-center",
      postalCode: "43452",
      city: "Port Clinton",
      countryCode: "US",
      name: "Port Clinton, Ohio Enrollment Center",
    },
    {
      waitTimeDays: 50,
      postalCode: "60607",
      shortName: "",
      countryCode: "US",
      state: "IL",
      coordinates: [41.87493, -87.651596],
      urlString: "chicago-field-office-enrollment-center",
      id: "11981",
      name: "Chicago Field Office Enrollment Center",
      city: "CHICAGO",
    },
    {
      id: "12021",
      urlString: "st-louis-enrollment-center",
      shortName: "St. Louis Enrollment Center",
      postalCode: "63145",
      waitTimeDays: 365,
      city: "St. Louis",
      name: "St. Louis Enrollment Center",
      countryCode: "US",
      state: "MO",
    },
    {
      waitTimeDays: 209,
      postalCode: "83705",
      countryCode: "US",
      coordinates: [43.561558, -116.214363],
      urlString: "boise-enrollment-center",
      state: "ID",
      id: "12161",
      shortName: "Boise Enrollment Center",
      city: "Boise",
      name: "Boise Enrollment Center",
    },
    {
      state: "MO",
      shortName: "Kansas City Enrollment Center",
      id: "12781",
      name: "Kansas City Enrollment Center",
      urlString: "kansas-city-enrollment-center",
      postalCode: "64153",
      countryCode: "US",
      coordinates: [39.274581, -94.726643],
      waitTimeDays: 104,
      city: "Kansas City",
    },
    {
      waitTimeDays: 2,
      city: "Blaine",
      shortName: "Blaine Global Entry Enrollment Center",
      postalCode: "98230",
      coordinates: [48.953455, -122.705013],
      name: "Blaine Global Entry Enrollment Center",
      urlString: "blaine-global-entry-enrollment-center",
      id: "13321",
      countryCode: "US",
      state: "WA",
    },
    {
      city: "Memphis",
      id: "13621",
      shortName: "Memphis International Airport Global Enrollment Ce",
      countryCode: "US",
      name: "Memphis Intl Airport Global Enrollment Center",
      urlString: "memphis-intl-airport-global-enrollment-center",
      postalCode: "38116",
      state: "TN",
      waitTimeDays: 112,
      coordinates: [35.033181, -90.011396],
    },
    {
      coordinates: [48.574989, -92.917067],
      id: "14181",
      countryCode: "US",
      urlString: "international-falls-global-entry-enrollment-center",
      postalCode: "56649",
      name: "International Falls Global Entry Enrollment Center",
      state: "MN",
      city: "International Falls",
      waitTimeDays: 1,
      shortName: "International Falls Global Entry Enrollment Center",
    },
    {
      shortName: "Charlotte-Douglas Airport",
      city: "Charlotte",
      postalCode: "28208",
      waitTimeDays: 365,
      urlString: "charlotte-douglas-international-airport",
      countryCode: "US",
      name: "Charlotte-Douglas International Airport",
      coordinates: [35.230466, -80.907243],
      id: "14321",
      state: "NC",
    },
    {
      state: "AK",
      urlString: "fairbanks-enrollment-center",
      coordinates: [64.862968, -148.164072],
      city: "Fairbanks",
      postalCode: "99709",
      id: "14381",
      shortName: "Fairbanks Enrollment Center",
      countryCode: "US",
      waitTimeDays: 0,
      name: "Fairbanks Enrollment Center",
    },
    {
      city: "Gulfport",
      state: "MS",
      shortName: "Gulfport-Biloxi Global Entry Enrollment Center",
      postalCode: "39503",
      id: "14481",
      waitTimeDays: 365,
      urlString: "gulfport-biloxi-global-entry-enrollment-center",
      countryCode: "US",
      coordinates: [30.474612, -89.152878],
      name: "Gulfport-Biloxi Global Entry Enrollment Center",
    },
    {
      waitTimeDays: 365,
      id: "14681",
      countryCode: "US",
      state: "CT",
      city: "Windsor Locks",
      name: "Bradley International Airport Enrollment Center",
      urlString: "bradley-international-airport-enrollment-center",
      postalCode: "06096",
      shortName: "Hartford, CT Enrollment Center",
    },
    {
      shortName: "Richmond, VA Enrollment Center",
      postalCode: "23250",
      coordinates: [37.504783, -77.320899],
      city: "Richmond",
      waitTimeDays: 365,
      urlString: "richmond-va-enrollment-center",
      name: "Richmond, VA Enrollment Center",
      state: "VA",
      countryCode: "US",
      id: "14981",
    },
    {
      waitTimeDays: 0,
      shortName: "Pembina Global Entry Enrollment Center",
      postalCode: "58271",
      id: "15221",
      name: "Pembina Global Entry Enrollment Center",
      countryCode: "US",
      urlString: "pembina-global-entry-enrollment-center",
      city: "Pembina",
      coordinates: [48.912895, -97.289694],
      state: "ND",
    },
    {
      state: "TX",
      shortName: "Eagle Pass Enrollment Center",
      name: "Eagle Pass ",
      urlString: "eagle-pass",
      countryCode: "US",
      id: "16226",
      waitTimeDays: 2,
      coordinates: [28.729787, -100.316678],
      city: "Eagle Pass",
      postalCode: "78852",
    },
    {
      postalCode: "45377",
      coordinates: [39.896083, -84.224285],
      urlString: "dayton-enrollment-center",
      city: "Vandalia",
      shortName: "Dayton Enrollment Center",
      id: "16242",
      state: "OH",
      waitTimeDays: 153,
      countryCode: "US",
      name: "Dayton Enrollment Center",
    },
    {
      countryCode: "US",
      postalCode: "34946",
      name: "Treasure Coast International Airport",
      city: "Fort Pierce",
      state: "FL",
      id: "16248",
      waitTimeDays: 85,
      coordinates: [27.503294, -80.36048],
      shortName: "Treasure Coast Intl. Airport",
      urlString: "treasure-coast-international-airport",
    },
    {
      waitTimeDays: 365,
      urlString: "sweetgrass-global-entry-enrollment-center",
      name: "Sweetgrass Global Entry Enrollment Center",
      coordinates: [48.967184, -111.658692],
      shortName: "Sweetgrass Global Entry",
      countryCode: "US",
      id: "16251",
      city: "Sweetgrass",
      postalCode: "59484",
      state: "MT",
    },
    {
      urlString: "tri-cities-enrollment-center",
      city: "Blountville",
      coordinates: [36.524578, -82.365576],
      shortName: "Tri-Cities Enrollment Center",
      postalCode: "37617",
      waitTimeDays: 365,
      state: "TN",
      name: "Tri-cities Enrollment Center",
      id: "16271",
      countryCode: "US",
    },
    {
      urlString: "huntsville-global-entry-enrollment-center",
      shortName: "Huntsville Enrollment Center",
      city: "Huntsville",
      countryCode: "US",
      name: "Huntsville Global Entry Enrollment Center",
      state: "AL",
      id: "16277",
      postalCode: "35824",
      waitTimeDays: 149,
      coordinates: [34.644914, -86.752068],
    },
    {
      shortName: "South Bend Int'l Airport",
      urlString: "south-bend-enrollment-center",
      postalCode: "46628",
      id: "16278",
      coordinates: [41.723298, -86.328342],
      name: "South Bend Enrollment Center",
      countryCode: "US",
      state: "IN",
      city: "South Bend",
      waitTimeDays: 365,
    },
    {
      name: "Grand Forks, ND enrollment Center",
      id: "16280",
      shortName: "Grand Forks Enrollment Center",
      urlString: "grand-forks-nd-enrollment-center",
      city: "Grand Forks",
      countryCode: "US",
      state: "ND",
      postalCode: "58203",
      waitTimeDays: 365,
      coordinates: [47.970477, -97.16549],
    },
    {
      city: "Mobile",
      name: "Mobile Regional Airport Enrollment Center",
      coordinates: [30.681503, -88.300213],
      waitTimeDays: 77,
      id: "16282",
      postalCode: "36608",
      countryCode: "US",
      urlString: "mobile-regional-airport-enrollment-center",
      state: "AL",
      shortName: "Mobile Enrollment Center",
    },
    {
      coordinates: [42.703095, -73.763706],
      state: "NY",
      urlString: "buffo-albany-international-airport",
      waitTimeDays: 365,
      city: "Albany",
      shortName: "Albany International Airport",
      postalCode: "12211",
      countryCode: "US",
      id: "16290",
      name: "BUFFO - Albany International Airport",
    },
    {
      name: "Del Rio Port of Entry, TX 2302",
      coordinates: [29.729903, -100.881337],
      postalCode: "78840",
      shortName: "Del Rio",
      city: " Del Rio",
      waitTimeDays: 34,
      id: "16460",
      state: "TX",
      urlString: "del-rio-port-of-entry-tx-2302",
      countryCode: "US",
    },
    {
      waitTimeDays: 365,
      urlString: "des-moines-ge-enrollment-center",
      postalCode: "50321",
      coordinates: [41.535138, -93.665248],
      name: "Des Moines GE Enrollment Center",
      shortName: "",
      state: "IA",
      city: "Des Moines",
      countryCode: "US",
      id: "16461",
    },
    {
      coordinates: [37.20745, -93.354612],
      countryCode: "US",
      city: "Springfield",
      postalCode: "65802",
      urlString: "springfield-–-branson-national-airport-mo",
      state: "MO",
      name: "Springfield – Branson National Airport, MO",
      waitTimeDays: 365,
      id: "16463",
      shortName: "",
    },
    {
      state: "NE",
      coordinates: [41.302498, -95.892524],
      countryCode: "US",
      waitTimeDays: 365,
      urlString: "omaha-ne-enrollment-center",
      id: "16467",
      shortName: "OMA-Eppley Airfield",
      name: "Omaha, NE Enrollment Center",
      city: "Omaha",
      postalCode: "68110",
    },
    {
      name: "SEAFO - Bozeman Airport",
      postalCode: "59714",
      coordinates: [45.980279, -111.129807],
      shortName: "",
      city: "Belgrade",
      id: "16475",
      countryCode: "US",
      state: "MT",
      waitTimeDays: 365,
      urlString: "seafo-bozeman-airport",
    },
    {
      state: "ND",
      waitTimeDays: 365,
      urlString: "seafo-fargo-global-entry-workshop",
      shortName: "",
      name: "SEAFO - FARGO Global Entry Workshop",
      city: "Fargo",
      coordinates: [46.927094, -96.834703],
      id: "16476",
      postalCode: "58102",
      countryCode: "US",
    },
    {
      state: "ND",
      id: "16482",
      countryCode: "US",
      coordinates: [47.970477, -97.16549],
      postalCode: "58203",
      name: "Grand Forks, ND Enrollment Event",
      shortName: "",
      city: "Grand Forks",
      urlString: "grand-forks-nd-enrollment-event",
      waitTimeDays: 365,
    },
    {
      coordinates: [45.892816, -108.497574],
      city: "Billings",
      name: "SEAFO - Billings-Logan Airport GE Mobile Event",
      id: "16485",
      waitTimeDays: 365,
      urlString: "seafo-billings-logan-airport-ge-mobile-event",
      postalCode: "59105",
      state: "MT",
      shortName: "",
      countryCode: "US",
    },
    {
      waitTimeDays: 365,
      id: "16488",
      coordinates: [46.971063, -114.111212],
      countryCode: "US",
      shortName: "Missoula Global Entry Event",
      postalCode: "59808",
      urlString: "seafo-missoula-international-airport",
      city: "Missoula",
      name: "SEAFO - Missoula International Airport",
      state: "MT",
    },
  ],
  updatedAt: "2022-02-21T23:04:14Z",
};
export default data;
